import React, { useState } from 'react'
import moment from 'moment'
import { TableRow, TableCell, Tooltip, Box, IconButton, Button } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import clsx from 'clsx'
import { EditStaffBenefit } from './EditStaffBenefit'
import { EditEndDateDialog } from './EditEndDateDialog'
import { DeleteStaffBenefitCodeDialog } from './DeleteStaffBenefitDialog'
import { StaffBenefitUsers } from './StaffBenefitUsers'
import { StaffBenefitRedemption } from './StaffBenefitRedemption'
import { makeStyles } from '@mui/styles'
import grey from '@mui/material/colors/grey'

const useStyles = makeStyles((theme) => ({
  expired: { backgroundColor: grey[100], color: grey[600] },
}))

export const StaffBenefitRow = (props) => {
  const classes = useStyles()
  const { row } = props
  const [editing, setEditing] = useState(false) //edit form
  const [openEditDate, setOpenEditDate] = useState(false) //for edit end date dialog
  const [openDelete, setOpenDelete] = useState(false) //for delete promo dialog
  const [openShowUser, setOpenShowUser] = useState(false) //for users collapsible
  const [openShowRedeemedUser, setopenShowRedeemedUser] = useState(false) //for redeemed users collapsible

  //handle close for edit end date dialog
  const handleClose = () => {
    setOpenEditDate(false)
  }

  //handle close for edit end date dialog
  const handleCloseDelete = () => {
    setOpenDelete(false)
  }

  const renderDiscount = () => {
    switch (row.type) {
      case 'Amount':
        return `RM${row.discountAmount} discount`
      case 'Percentage':
        return `${+(Math.round(row.discountPercentage * 100 + 'e+2') + 'e-2')}% discount`
      case 'Gift':
        return `Free Gift: ${row.freeGift}`
      default:
        break
    }
  }

  return (
    <React.Fragment>
      <TableRow
        className={clsx({
          [classes.expired]:
            (!isNaN(row.redemptionLimit) &&
              row.redemptionLimit &&
              row.redemptionLimit !== 0 &&
              row.count >= row.redemptionLimit) ||
            (row.endDate && moment(row.endDate).isBefore(moment())),
        })}
      >
        <TableCell component='th' scope='row'>
          {row.staffBenefitCode}
        </TableCell>
        <TableCell component='th' scope='row'>
          {row.name}
        </TableCell>
        <TableCell align='right'>{row.message}</TableCell>
        <TableCell align='right'>{renderDiscount()}</TableCell>
        <TableCell align='center'>
          <Box ml={2} mr={2}>
            <Button
              variant={row.users.length > 0 ? 'outlined' : 'text'}
              size='small'
              onClick={() =>
                (row.users.length > 0 || row.departments?.length > 0) &&
                setOpenShowUser(!openShowUser)
              }
              style={{ textTransform: 'none' }}
            >
              {row.users.length === 0 ? 'All' : row.users.length}
            </Button>
          </Box>
        </TableCell>
        <TableCell align='center'>
          <Button
            variant={row.count ? 'outlined' : 'text'}
            size='small'
            onClick={() => row.redeemed && setopenShowRedeemedUser(!openShowRedeemedUser)}
          >
            {row.count || 0}
            {row.redemptionLimit > 0 && ` / ${row.redemptionLimit}`}
          </Button>
        </TableCell>
        <TableCell align='right'>
          <Box display='flex' flexDirection='row' alignItems='center' justifyContent='flex-end'>
            {moment(row.startDate).format('D/M/YYYY')} - {moment(row.endDate).format('D/M/YYYY')}
            <Tooltip title='Edit ending date'>
              <IconButton
                style={{ padding: '3px 3px' }}
                onClick={() => setOpenEditDate(!openEditDate)}
              >
                <EditIcon fontSize='small' />
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
        <TableCell align='right'>
          <Box display='flex' justifyContent='space-evenly'>
            <Tooltip title='Edit Promotion'>
              <IconButton onClick={() => setEditing(!editing)}>
                <EditIcon size='small' />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete Promotion'>
              <IconButton onClick={() => setOpenDelete(!openDelete)}>
                <DeleteIcon size='small' />
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
      <EditStaffBenefit row={row} editing={editing} setEditing={setEditing} />
      <EditEndDateDialog openEditDate={openEditDate} onClose={handleClose} row={row} />
      <DeleteStaffBenefitCodeDialog openDelete={openDelete} onClose={handleCloseDelete} row={row} />
      <StaffBenefitUsers row={row} openShowUser={openShowUser} />
      <StaffBenefitRedemption row={row} openShowRedeemedUser={openShowRedeemedUser} />
    </React.Fragment>
  )
}
